import { NgIf, NgIfContext } from '@angular/common';
import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { App } from '@df/core/app';
import { Meta } from '@df/core/meta/meta';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[ifUrlNotContain]',
    standalone: true
})
export class IfUrlNotContainDirective extends NgIf implements OnInit, OnDestroy {
    @Input({ required: true })
    ifUrlNotContain!: string | string[];

    protected lastConditionValue?: boolean;
    protected subscriptions: Subscription = new Subscription();

    constructor(
        viewContainerRef: ViewContainerRef,
        templateRef: TemplateRef<NgIfContext<unknown>>,
        private app: App,
        private meta: Meta
    ) {
        super(viewContainerRef, templateRef);
    }

    ngOnInit(): void {
        if (!this.app.isPlatformBrowser) return;

        this.subscriptions.add(
            this.meta.routerEvents.subscribe(routerEvent => {
                if (routerEvent instanceof NavigationEnd) {
                    this.updateView();
                }
            })
        );

        this.updateView();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get condition() {
        return !this.isForbidden();
    }

    /**
     * Check if url is forbidden
     */
    private isForbidden(): boolean {
        const currentPath = window.location.pathname;

        if (Array.isArray(this.ifUrlNotContain)) {
            return !!this.ifUrlNotContain.find(url => currentPath.includes(url));
        } else {
            return currentPath.includes(this.ifUrlNotContain);
        }
    }

    /**
     * Applies condition
     */
    private updateView(): void {
        const condition = this.condition;

        if (!!this.lastConditionValue === condition) {
            return;
        }

        this.lastConditionValue = condition;
        this.ngIf = condition;
    }
}
